export default __webpack_public_path__ + "static/media/girl_pink_bike.6625bb95.jpg";